import { Absent_getInstance2zpu0zcae0yg1 as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SavePlayerInputClass;
function SavePlayerInput() {
  if (SavePlayerInputClass === VOID) {
    class $ {
      constructor(partyId, playerId, name, email, badge, callSignAdjective, callSignNoun, imageURL, avatarType, unvalidatedEmails) {
        imageURL = imageURL === VOID ? Absent_getInstance() : imageURL;
        avatarType = avatarType === VOID ? Absent_getInstance() : avatarType;
        this.f6v_1 = partyId;
        this.g6v_1 = playerId;
        this.h6v_1 = name;
        this.i6v_1 = email;
        this.j6v_1 = badge;
        this.k6v_1 = callSignAdjective;
        this.l6v_1 = callSignNoun;
        this.m6v_1 = imageURL;
        this.n6v_1 = avatarType;
        this.o6v_1 = unvalidatedEmails;
      }
      toString() {
        return 'SavePlayerInput(partyId=' + this.f6v_1.toString() + ', playerId=' + this.g6v_1.toString() + ', name=' + this.h6v_1 + ', email=' + this.i6v_1 + ', badge=' + this.j6v_1.toString() + ', callSignAdjective=' + this.k6v_1 + ', callSignNoun=' + this.l6v_1 + ', imageURL=' + toString(this.m6v_1) + ', avatarType=' + toString(this.n6v_1) + ', unvalidatedEmails=' + toString(this.o6v_1) + ')';
      }
      hashCode() {
        var result = this.f6v_1.hashCode();
        result = imul(result, 31) + this.g6v_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.h6v_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.i6v_1) | 0;
        result = imul(result, 31) + this.j6v_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.k6v_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.l6v_1) | 0;
        result = imul(result, 31) + hashCode(this.m6v_1) | 0;
        result = imul(result, 31) + hashCode(this.n6v_1) | 0;
        result = imul(result, 31) + hashCode(this.o6v_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePlayerInput()))
          return false;
        if (!this.f6v_1.equals(other.f6v_1))
          return false;
        if (!this.g6v_1.equals(other.g6v_1))
          return false;
        if (!(this.h6v_1 === other.h6v_1))
          return false;
        if (!(this.i6v_1 === other.i6v_1))
          return false;
        if (!this.j6v_1.equals(other.j6v_1))
          return false;
        if (!(this.k6v_1 === other.k6v_1))
          return false;
        if (!(this.l6v_1 === other.l6v_1))
          return false;
        if (!equals(this.m6v_1, other.m6v_1))
          return false;
        if (!equals(this.n6v_1, other.n6v_1))
          return false;
        if (!equals(this.o6v_1, other.o6v_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePlayerInput');
    SavePlayerInputClass = $;
  }
  return SavePlayerInputClass;
}
//region block: exports
export {
  SavePlayerInput as SavePlayerInput3s7vno6nbe1ix,
};
//endregion

//# sourceMappingURL=SavePlayerInput.mjs.map
